import selectEntityDialogFactory from './selectEntityDialogFactory';
import Group from '../../type/Group';

const SelectGroupsDialog = selectEntityDialogFactory<Group>(
  'No Groups Found',
  (allSelected: boolean, isFiltering: boolean) =>
    (allSelected ? 'Deselect All' : 'Select All') + (isFiltering ? ' Groups' : ''),
);
export default SelectGroupsDialog;
